import type { PiniaPluginContext, Store } from 'pinia'

const stores = new Set<Store>()

/** Pinia plugin: tracks every instantiated store so logout can reset them all. */
export function storeRegistryPlugin({ store }: PiniaPluginContext) {
  stores.add(store)
}

/** Setup stores must expose their own `$reset`; stores without one are skipped. */
export function resetAllStores(except: string[] = []) {
  for (const store of stores) {
    if (except.includes(store.$id)) continue
    if (typeof (store as { $reset?: unknown }).$reset === 'function') store.$reset()
  }
}
